export default "__VITE_ASSET__3bf06b81__"